export default "__VITE_ASSET__86b1cf40__"